import "./App.css";
import Nav from "./Components/Nav";
import Banner from "./Components/Banner";
import Row from "./Components/Row";
import requests from "./requests";
function App() {
  const {
    fetchTrending,
    fetchNetflixORiginals,
    fetchTopRatedMovies,
    fetchActionMovies,
    fetchComedyMovies,
    fetchHorrorMovies,
    fetchRomanceMovies,
    fetchDocumentaries,
  } = requests;
  return (
    <div className="App">
      <Nav />
      <Banner />
      <Row
        title="NETFLIX ORIGINALS"
        fetchUrl={fetchNetflixORiginals}
        isLargeRow
      />
      <Row title="Trending Now" fetchUrl={fetchTrending} />
      <Row title="Top Rated" fetchUrl={fetchTopRatedMovies} />
      <Row title="Action movies" fetchUrl={fetchActionMovies} />
      <Row title="Comedy movies" fetchUrl={fetchComedyMovies} />
      <Row title="Horror movies" fetchUrl={fetchHorrorMovies} />
      <Row title="Romance movies" fetchUrl={fetchRomanceMovies} />
      <Row title="Documentaries" fetchUrl={fetchDocumentaries} />
    </div>
  );
}

export default App;
